@if(showHeader){
<fgb-banner [pageName]="'wallet.page.title'"></fgb-banner>
}
<router-outlet></router-outlet>
